import React from "react";

const MobileOrnamentsSvg = ({ className, width = "100%", height = "100%" }) => {
  const subtractFromMenuWidth = (pixelsToSubtract) => {
    return window.screen.width - pixelsToSubtract;
  };

  const subtractFromMenuHeight = (pixelsToSubtract) => {
    return height - pixelsToSubtract;
  };

  // Default fixed values
  const topLeftBoxX = 12;
  const topLeftBoxY = 12;
  const topLeftBoxWidth = 19;
  const topLeftBoxHeight = 19;

  // Horizontal line 1
  const hLine1X1 = 20;
  const hLine1Y = 24;
  const hLine1X2 = subtractFromMenuWidth(60);

  // Horizontal line 2
  const hLine2X1 = 136;
  const hLine2Y = subtractFromMenuHeight(24);
  const hLine2X2 = subtractFromMenuWidth(6);

  // Vertical line 1
  const vLine1X = 24;
  const vLine1Y1 = 20;
  const vLine1Y2 = subtractFromMenuHeight(146);

  // Vertical line 2
  const vLine2X = subtractFromMenuWidth(24);
  const vLine2Y1 = 60;
  const vLine2Y2 = subtractFromMenuHeight(7);

  return (
    <svg
      width={width}
      height={height}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Top-left corner box */}
      <rect
        x={topLeftBoxX}
        y={topLeftBoxY}
        width={topLeftBoxWidth}
        height={topLeftBoxHeight}
        fill="none"
        stroke="#696969"
        strokeWidth="0.5"
      />

      {/* Horizontal lines */}
      <line
        x1={hLine1X1}
        y1={hLine1Y}
        x2={hLine1X2}
        y2={hLine1Y}
        stroke="#696969"
        strokeWidth="0.5"
      />
      <line
        x1={hLine2X1}
        y1={hLine2Y}
        x2={hLine2X2}
        y2={hLine2Y}
        stroke="#696969"
        strokeWidth="0.5"
      />

      {/* Vertical lines */}
      <line
        x1={vLine1X}
        y1={vLine1Y1}
        x2={vLine1X}
        y2={vLine1Y2}
        stroke="#696969"
        strokeWidth="0.5"
      />
      <line
        x1={vLine2X}
        y1={vLine2Y1}
        x2={vLine2X}
        y2={vLine2Y2}
        stroke="#696969"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default MobileOrnamentsSvg;
